import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import Store from "../../Store/Store";
import { BankAccountInterface } from "../../Entity/Entities/BankAccount/BankAccountInterface";

class PontoProcessing extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const processingStatus = props?.res?.processingStatus;
    
    const bankAccount = Store.getConfigurator().getState().app.bankAccounts
      .filter((bankAccount: BankAccountInterface) =>  bankAccount.pontoIntegration?.isConnected);

      if (bankAccount.length > 0 && bankAccount[0]?.pontoIntegration) {
        bankAccount[0].pontoIntegration.processingStatus = processingStatus;

        this.props.dispatch({
          type: Constants.GLOBAL_BANK_ACCOUNT_UPDATE_SUCCESS,
          payload: {
            bankAccount: bankAccount[0]
          },
        });
      }

      if (processingStatus === "finished" || processingStatus !== "started") {
        this.props.dispatch({
          type: Constants.PONTO_SYNCHRONIZATION_BUTTON_DISABLED,
          payload: false
        });
      }
  }
}

export { PontoProcessing };
